import { getStore, isCloudCacheLoaded } from "../store/store";
import { isEasiIdUser } from "./isEasiIdUser";

export function isEasiIdUserWithoutCloudCache(): boolean {
    if (!isEasiIdUser()) {
        return false;
    }
    
    // it is necessary to check if cloudcache is loaded before believe that we
    // have a valid information.
    if (!isCloudCacheLoaded()) {
        return false;
    }
    
    if (getStore().cloudCacheConfigItem.emailAddress) {
        return false;
    }
    
    return true;
}
